import { NgModule } from '@angular/core';
import { NoPreloading, RouterModule, Routes } from '@angular/router';

import { HsgOidcLogoutComponent, HsgRouteGuardService } from '@hhsg/hsg-asc';

import { LoginComponent } from './login/login.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { WorkforceRouteGuardService } from './workforce-route-guard.service';
import { WorkflowComponent } from './workflow/workflow.component';
import { CostCenterSelectComponent } from './workflow/cost-center-select/cost-center-select.component';
import { ShiftBlockSelectComponent } from './workflow/shift-block-select/shift-block-select.component';
import { PlannerComponent } from './workflow/planner/planner.component';
import { InpatientReviewPreviousComponent } from './workflow/inpatient/review-previous/review-previous.component';
import { InpatientEnterCurrentComponent } from './workflow/inpatient/enter-current/enter-current.component';
import { EnterReasonsComponent } from './workflow/enter-reasons/enter-reasons.component';
import { AcuityEnterCurrentComponent } from './workflow/acuity/enter-current/enter-current.component';
import { AcuityReviewPreviousComponent } from './workflow/acuity/review-previous/review-previous.component';
import { ReviewPreviousRoomsComponent } from './workflow/acuity-rooms/review-previous-rooms/review-previous-rooms.component';
import { EnterCurrentRoomsComponent } from './workflow/acuity-rooms/enter-current-rooms/enter-current-rooms.component';
import { EnterUOSComponent } from './workflow/enter-uos/enter-uos.component';

const routes: Routes = [
	{
		path: 'login',
		component: LoginComponent,
	},
	{
		path: 'logout',
		component: HsgOidcLogoutComponent
	},
	{
		path: 'unauthorized',
		component: UnauthorizedComponent
	},
	{
		path: 'smt',
		loadChildren: () => import('./smt/workforce.module').then(m => m.WorkforceModule),
		canActivate: [WorkforceRouteGuardService]
	},
	{
		path: 'workflow',
		component: WorkflowComponent,
		children: [
			{ path: 'cost-center', component: CostCenterSelectComponent },
            { path: 'shift-block/:cost_center', component: ShiftBlockSelectComponent },
            { path: 'inpatient-review-previous', component: InpatientReviewPreviousComponent },
            { path: 'inpatient-enter-current', component: InpatientEnterCurrentComponent },
            { path: 'acuity-enter-current', component: AcuityEnterCurrentComponent },
			{ path: 'acuity-review-prevous', component: AcuityReviewPreviousComponent },
			{ path: 'acuity-rooms-enter-current', component: EnterCurrentRoomsComponent },
			{ path: 'acuity-rooms-review-prevous', component: ReviewPreviousRoomsComponent },
			{ path: 'enter-uos', component: EnterUOSComponent },
            { path: 'reasons', component: EnterReasonsComponent },
            { path: 'planner', component: PlannerComponent }
		],
        canActivate: [WorkforceRouteGuardService, HsgRouteGuardService],
        runGuardsAndResolvers: 'always'
	}
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, {
			useHash: false,
			preloadingStrategy: NoPreloading,
			// for debugging
            enableTracing: true,
            onSameUrlNavigation: 'reload'
		})
	],
	exports: [RouterModule]
})
export class AppRoutingModule { }
